document.addEventListener("DOMContentLoaded", function () {
    let popup = document.querySelector(".layout-part--header-page-home");
	let header = document.querySelector(".main-header");

    if (popup) {
        setTimeout(() => {
			jQuery(popup).fadeOut(700);
			header.style.background = "transparent";
        }, 5000); // 5 segundos
    }
});